import {GET_FORM_BY_SNAPSHOT_ID} from '../../../actions/Ares/actiontypes';
import {normalize} from '../../../util/utils';

export function aresFormDataReducer(state = {}, action) {
	switch (action.type) {
		case GET_FORM_BY_SNAPSHOT_ID:
			return {
				...state,
				snapshots: normalize(
					[
						{
							id: action.snapshotId,

							// TODO: Api should normalize both responses based on sourceSnapshotId!
							headers: normalize(action.sourceSnapshotId !== undefined ? action.response : action.response.snapshotData)
						}
					],
					undefined,
					state.snapshots
				)
			};
		default:
			return state;
	}
}
